<template>
	<a
		class="footer-tapbar__button"
		:href="link"
	>
		<i
			class="icon icon-cart-2 footer-tapbar__icon footer-tapbar__icon--counter"
			:data-counter="count || null"
		></i>
		<span class="footer-tapbar__text ellipsis">Корзина</span>
	</a>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
	href?: string;
}

const props = defineProps<Props>();

const store = window.app.store;

const count = computed(() => store.count.cart ?? 0);
const link = computed(() => props.href || '#');
</script>
